export const transformObjectKeyToTitle = (key: string) => {
  const words = key.split('_');

  return words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
};
